import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/research-bar')({
  component: Outlet,
  beforeLoad: ({ location }) => {
    if (location.pathname === '/research-bar' || location.pathname === '/research-bar/') {
      throw redirect({ to: '/recherche', replace: true })
    }
  },
})
